import { render } from "./DuoToneTeamingWordLogo.vue?vue&type=template&id=5ed3119a&scoped=true"
import script from "./DuoToneTeamingWordLogo.vue?vue&type=script&lang=js"
export * from "./DuoToneTeamingWordLogo.vue?vue&type=script&lang=js"

import "./DuoToneTeamingWordLogo.vue?vue&type=style&index=0&id=5ed3119a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ed3119a"

export default script